/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unit: NonNullable<unknown> }} Exercise_Sheet_How_AssistedInputs */

const en_us2_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Log the machine's assistance, in the “${i?.unit}” field; it is taken off your body weight.`)
};

const pt_br2_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registre a assistência da máquina, no campo “${i?.unit}”; ela é descontada do seu peso corporal.`)
};

const es_419_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra la asistencia de la máquina, en el campo “${i?.unit}”; se descuenta de tu peso corporal.`)
};

const pt_pt2_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regista a assistência da máquina, no campo “${i?.unit}”; é descontada do teu peso corporal.`)
};

const fr_fr2_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Note l'assistance de la machine, dans le champ « ${i?.unit} » ; elle est déduite de ton poids de corps.`)
};

const de_de2_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trag die Unterstützung der Maschine im Feld „${i?.unit}“ ein; sie wird von deinem Körpergewicht abgezogen.`)
};

const it_it2_exercise_sheet_how_assisted = /** @type {(inputs: Exercise_Sheet_How_AssistedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra l'assistenza della macchina, nel campo “${i?.unit}”; viene sottratta dal tuo peso corporeo.`)
};

/**
* | output |
* | --- |
* | "Log the machine's assistance, in the “{unit}” field; it is taken off your body weight." |
*
* @param {Exercise_Sheet_How_AssistedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_how_assisted = /** @type {((inputs: Exercise_Sheet_How_AssistedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_How_AssistedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_how_assisted(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_how_assisted(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_how_assisted(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_how_assisted(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_how_assisted(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_how_assisted(inputs)
	return en_us2_exercise_sheet_how_assisted(inputs)
});
export { exercise_sheet_how_assisted as "exercise-sheet.how_assisted" }